import { useEffect, useState } from 'react'
import { ReactSVG } from 'react-svg'

interface LogoProps {
	width?: number
	height?: number
	variant?: 'full' | 'compact'
	[key: string]: unknown
}

export function Logo({ width, height, variant, ...props }: LogoProps) {
	const [isMobile, setIsMobile] = useState(false)

	useEffect(() => {
		const checkScreenSize = () => {
			setIsMobile(window.innerWidth < 768)
		}

		checkScreenSize()
		window.addEventListener('resize', checkScreenSize)

		return () => {
			window.removeEventListener('resize', checkScreenSize)
		}
	}, [])

	// Logo selection: Uses brand-agnostic names
	const useCompact = variant === 'full' ? false : variant === 'compact' ? true : isMobile
	const logoSrc = useCompact ? '/images/logos/logo-compact.svg' : '/images/logos/logo-full.svg'

	// Aspect ratios: square logo (1:1) for mobile, rectangular logo (~3.93:1) for desktop
	const aspectRatio = useCompact ? 1.0 : 2048 / 512 // logo-full.svg aspect ratio

	// Default height
	const defaultHeight = 40

	let logoWidth: number
	let logoHeight: number

	if (height !== undefined) {
		// If height is provided, calculate width from height using aspect ratio
		logoHeight = height
		logoWidth = height * aspectRatio
	} else if (width !== undefined) {
		// If width is provided, calculate height from width using aspect ratio
		logoWidth = width
		logoHeight = width / aspectRatio
	} else {
		// Use defaults: calculate width from default height
		logoHeight = defaultHeight
		logoWidth = defaultHeight * aspectRatio
	}

	return (
		<ReactSVG
			{...props}
			src={logoSrc}
			beforeInjection={svg => {
				let style = ''
				if (logoWidth) {
					style += `width: ${logoWidth}px;`
				}
				if (logoHeight) {
					style += `height: ${logoHeight}px;`
				}

				svg.setAttribute('style', style)
			}}
		/>
	)
}
